<template>
    <div class="main-filters">
        <div class="main-filters__search">
            <el-input
                v-model="searchText"
                style="width: 100%"
                :placeholder="translate('search_placeholder')"
                @input="pesquisar"
            >
                <template #prefix>
                    <i class="el-icon-search"></i>
                </template>
            </el-input>
            <el-popover
                v-model="showModalAdvancedFilters"
                trigger="manual"
                width="520"
                offset="0"
            >
                <template #reference>
                    <el-button
                        type="text"
                        icon="el-icon-s-operation"
                        class="main-filters__btn_advanced_filters"
                        @click="showModalAdvancedFilters = !showModalAdvancedFilters"
                    >
                        {{ translate('btn_advanced_filters') }}
                    </el-button>
                </template>
                <template #default>
                    <div class="advanced-filters-popover">
                        <h4 class="advanced-filters-popover__title">{{ translate('btn_advanced_filters') }}</h4>
                        <el-form label-position="top" size="small">
                            <el-form-item :label="translate('date_range')">
                                <el-date-picker
                                    v-model="dateRange"
                                    type="daterange"
                                    style="width: 100%"
                                    :start-placeholder="translate('date_start')"
                                    :end-placeholder="translate('date_end')"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                />
                            </el-form-item>
                        </el-form>
                        <div class="advanced-filters-popover__actions">
                            <el-button size="small" @click="clearFilters">
                                {{ translate('clear_filters') }}
                            </el-button>
                            <el-button size="small" type="primary" @click="applyFilter">
                                {{ translate('apply_filters') }}
                            </el-button>
                        </div>
                    </div>
                </template>
            </el-popover>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InboundInvoicesFilters',
    data() {
        return {
            showModalAdvancedFilters: false,
            searchText: '',
            dateRange: null
        };
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.messages.inbound_invoices_filter';
            return this.$t(`${base}.${key}`, params);
        },
        pesquisar() {
            if (this.searchText.length >= 1 && this.searchText.length < 3) {
                return;
            }
            this.emitFilters();
        },
        applyFilter() {
            this.showModalAdvancedFilters = false;
            this.emitFilters();
        },
        clearFilters() {
            this.searchText = '';
            this.dateRange = null;
            this.showModalAdvancedFilters = false;
            this.emitFilters();
        },
        emitFilters() {
            this.$emit('changeFilters', {
                filtroTexto: this.searchText,
                dataInicio: this.dateRange ? this.dateRange[0] : null,
                dataFim: this.dateRange ? this.dateRange[1] : null
            });
        }
    },
    beforeDestroy() {
        this.clearFilters();
    }
};
</script>

<style scoped lang="scss">
.main-filters {
    .main-filters__search {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 16px;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .el-input {
            i.el-icon-search {
                color: #183b57;
                font-size: 20px;
                margin: 10px 2px;
            }
        }

        .main-filters__btn_advanced_filters {
            border: 1px solid #183b57;
            font-size: 14px;
            padding: 9px 16px;
            height: 40px;
        }
    }
}

.advanced-filters-popover {
    padding: 4px;

    &__title {
        font-size: 15px;
        font-weight: 600;
        color: #3b3b3b;
        margin: 0 0 16px 0;
    }

    &__actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-top: 16px;
    }
}
</style>
